// How high Helvetica's capitals and figures stand, in its size: a text set
// at the bottom of its box stands on the box's foot, this high
export const CAP_HEIGHT = 0.72
// How far its round letters, an O's, a G's, rise over its capitals, in its
// size: a text kept within its box sets them that much lower
export const OVERSHOOT = 0.015
